import { Check } from "lucide-react";

export function CheckChip({ on, onClick, children, testId, className = "" }) {
  return (
    <button type="button" onClick={onClick} aria-pressed={on} data-testid={testId}
      className={`px-4 py-3 rounded-2xl border text-left flex items-center justify-between gap-3 font-semibold text-sm transition-[background-color,border-color,transform] duration-200 active:scale-[0.97] ${
        on ? "border-primary bg-primary/10" : "bg-card hover:border-foreground/30"
      } ${className}`}>
      {children}
      <span className={`h-5 w-5 shrink-0 rounded-md border flex items-center justify-center transition-colors ${on ? "bg-primary border-primary text-white" : "border-foreground/25"}`}>
        {on && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
      </span>
    </button>
  );
}
